import React, { useState } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typography, colors, Button, Radio } from '@leapeasy/ui-kit';

import { Grid, Box, Dialog, DialogContent, DialogActions } from '@mui/material';

import { setDataAction } from 'redux/actions/getFormActions';
import { sendEmailVerificationAction } from 'redux/actions/emailActions';
import ConcernIcon from '../components/ConcernIcon';

const Form1 = (props) => {
  const { handleNext } = props;
  const [hasAccount, setHasAccount] = useState(null);
  const [openDlg, setOpenDlg] = useState(false);

  const handleChange = (value) => {
    setHasAccount(value);
    setOpenDlg(value === 'yes' ? true : false);
  };

  const handleNextButton = () => {
    handleNext();
  };

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography variant="body1" style={{ color: colors.purple[900], fontWeight: '600' }}>
          Welcome!
        </Typography>

        <Typography variant="body1" style={{ color: colors.purple[900] }}>
          Before we begin, do you already have a recent active application with Leap?
        </Typography>
      </Box>

      <Box display="flex" alignItems="flex-start" sx={{ gap: '24px' }}>
        <Radio label="Yes" value={hasAccount === 'yes'} onChange={(_) => handleChange('yes')} />
        <Radio label="No" value={hasAccount === 'no'} onChange={(_) => handleChange('no')} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2 }}>
        <Button
          size="medium"
          onClick={handleNextButton}
          variant="primary"
          disabled={hasAccount !== 'no'}
        >
          <Typography variant="body1">Next</Typography>
        </Button>
      </Box>

      <Dialog open={openDlg} maxWidth="xs" onClose={() => setOpenDlg(false)}>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '24px 20px',
          }}
        >
          <ConcernIcon />

          <Typography variant="body1" style={{ fontWeight: '600', textAlign: 'center' }}>
            Contact Us for Application Concerns
          </Typography>

          <Typography
            variant="body2"
            style={{ textAlign: 'center', color: colors.neutral[900], marginTop: '8px' }}
          >
            If you have application concerns, contact us at{' '}
            <a href="mailto:underwriting@leapeasy.com" style={{ color: colors.purple[900] }}>
              underwriting@leapeasy.com
            </a>{' '}
            instead of applying again.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ padding: '24px 20px', paddingTop: 0 }}>
          <Grid container justifyContent="center">
            <Button
              size="medium"
              variant="primary"
              onClick={() => setOpenDlg(false)}
              style={{ width: '100%' }}
            >
              Close
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.formData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        setDataAction,
        sendEmailVerificationAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form1);
